import React, { useEffect, useState } from "react";
import ProjectSnapshot from "../components/ProjectSnapshot";
import database from "../firebase";
import { Link } from "react-router-dom";

const Pro = () => {
  const [proImages, setProimages] = useState([]);

  useEffect(() => {
    database
      .collection("myprojects")
      .orderBy("projectName")
      .onSnapshot((snapshot) =>
        setProimages(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            data: doc.data(),
          }))
        )
      );
  }, []);

  return (
    <div className="bg-[#06202A] text-white pt-3">
      <h1 className="text-center text-white mb-5 text-xl font-semibold">
        Project Snapshot
      </h1>
      <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 sm:items-center">
        {proImages.map(({ id, data: { imageUrl, projectName } }) => (
          <ProjectSnapshot key={id} source={imageUrl} title={projectName} />
        ))}
      </div>

      <div className="flex justify-center mt-4 pb-5">
        <Link to="/">
          <button className="px-6 py-2 text-white focus:outline-none rounded-sm bg-transparent border border-gray-50 hover:bg-gray-100 hover:text-black">
            Home
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Pro;
